import React from 'react';
import { Text as RNText, TextProps as RNTextProps } from 'react-native';
import s, { getFontFamily } from './Typography.styles';

export type Caption3Props = RNTextProps & {
  weight?: 'regular' | 'semibold';
  uppercase?: boolean;
};

export const Caption3: React.FC<Caption3Props> = ({
  children,
  weight = 'regular',
  uppercase = false,
  style,
  ...props
}) => {
  return (
    <RNText
      style={[
        s.common,
        s.caption3,
        uppercase && s.caption3Caps,
        {
          textTransform: uppercase ? 'uppercase' : 'none',
        },
        getFontFamily(weight),
        style,
      ]}
      {...props}
    >
      {children}
    </RNText>
  );
};
